import {addClass, removeClass} from './helpers';

export const loader = () => {
  const headerLogoSymbolsAnim = (delayShow, delayHide) => {
    const _headerLogo = document.querySelector('.header__logo');
    if (!_headerLogo) return;

    setTimeout(function run() {
      addClass(_headerLogo, 'full');
      setTimeout(() => {
        removeClass(_headerLogo, 'full');
      }, delayHide);
    }, delayShow)

  };

  window.addEventListener('load', function (evt) {
    let tS = 400 - (Date.now() - window.__openTime);
    if (tS < 50) {
      tS = 50;
    }
    setTimeout(() => {
      addClass(document.body, 'is-loaded');

      // Show Logo
      headerLogoSymbolsAnim(1500, 5000);

      // Show WhatsUp button after 5 sec after loading
      setTimeout(() => {
        document.querySelectorAll('.float-btn').forEach((btn) => {
          removeClass(btn, 'default-hidden');
        });
      }, 5000);
    }, tS);

    // const createStripe = (parent, count = 1) => {
    //   console.log('count - ', count);
    //   for (let i = 1; i <= count; i++) {
    //     const stripe = document.createElement('span');
    //     stripe.classList.add('anim-stripe');
    //     const stripePosition = (100 / count) * (count - i);
    //
    //     stripe.style.bottom = `${stripePosition}%`;
    //     stripe.style.height = `${(100 / count)}%`;
    //     parent.insertAdjacentElement('beforeend', stripe);
    //     console.log(1);
    //   }
    // }
    //
    // const seeTitle = () => {
    //   const stripeTitles = document.querySelectorAll('[data-stripe-title]');
    //
    //   stripeTitles.forEach((title) => {
    //     const compStyles = window.getComputedStyle(title);
    //     const titleHeight = title.clientHeight;
    //     let lineHeight = compStyles.getPropertyValue('line-height');
    //     console.log(lineHeight);
    //     lineHeight = Math.round(parseFloat(lineHeight));
    //     console.log(titleHeight,  lineHeight);
    //     const lineCount = Math.round(titleHeight / lineHeight);
    //     createStripe(title, lineCount)
    //   })
    // }
    // seeTitle();
  });
};
